<template>
    <component :is="product" />
</template>

<script>
import { mapGetters } from 'vuex'

import PublicCatalogProduct from '@/components/Public/Catalog/Product/PublicCatalogProduct.vue'

export default {
    name: 'PublicCatalogProductID',

    components: {
        PublicCatalogProduct,
    },

    computed: {
        ...mapGetters('user', ['isRetailer']),
        product() {
            return PublicCatalogProduct
        }
    }
}
</script>
